import { wa } from 'apps/analytics';
import Locations from 'apps/basket/models/Locations';
import routeMonitor from 'utils/routeMonitor';

export default function getAnalyticsData(product) {
  return {
    product,
    section: { id: `${wa.getPageViewId()}.BOP` },
    pageType: Locations.BOP,
    productsPageRouteLocationQuery: { entry: getSourceSearchTermIfExists() },
  };
}

function getSourceSearchTermIfExists() {
  const previousPath = routeMonitor ? routeMonitor.getPreviousRoute() : '';
  const searchEntryWithOtherParams = previousPath.split('entry=');
  return searchEntryWithOtherParams.length > 1 ? searchEntryWithOtherParams[1].split('&')[0] : undefined;
}
